import type { AudienceSegment, AudienceSnapshot } from './types';

export function snapshotFromSegment(segment: AudienceSegment): AudienceSnapshot {
  return {
    audienceId: segment.id,
    audienceName: segment.name,
    total: segment.total,
    eligible: segment.eligible,
    excludedNoConsent: segment.excludedNoConsent,
    excludedUnsubscribed: segment.excludedUnsubscribed,
    excludedInvalid: segment.excludedInvalid,
  };
}
